import useAppSelector from "./base/useAppSelector";

const useViewDataObject = (viewType) => {
  const object = useAppSelector((state) => {
    return state.ViewData.viewDataPage.object;
  });

  const isObjectLoaded = viewType === object?.viewType;
  if (isObjectLoaded) {
    return { object, data: object?.data };
  }
  return { object: null, data: null };
};

export default useViewDataObject;
